module.exports = __webpack_public_path__ + "static/media/Milex-Gellhorn-Pessary-Instructions-for-Use.6b829e8d.jpg";